'use strict';
import { Component, Inject, Input, EventEmitter, Output} from 'ng-metadata/core';
import {SendEmailService} from './sendEmail.service';
import {JwtUtilService} from '../../../security/jwtUtil.service';
import {StorageUtil} from "../../../infra/storageUtil.service";
import {getCaptcha} from '../../../appConfig/appConfigForward';
import {PrimoResponse} from '../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import { RtaService } from '../../rta.service';

const _get = require('lodash/get');

var angular:angular.IAngularStatic =  require('angular');

@Component({
    providers: [SendEmailService],
    "selector": 'prm-send-email',
    templateUrl: 'components/search/actions/sendEmailAction/send-email.html'
})


export class PrmSendEmail{
    @Input() item: PrimoResponse.IDoc[];
    @Input() selectedIds: any;
    @Input() isFullView: boolean;
    @Output() finishedEmailEvent = new EventEmitter<void>();

    private emailRegExAll = /^(([a-zA-Z0-9\.\!\#\$\%\&\'\*\+\-\/\=\?\^\_\`\{\|\}\~]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;|,]\s*(([a-zA-Z0-9\.\!\#\$\%\&\'\*\+\-\/\=\?\^\_\`\{\|\}\~]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
    private urlPattern = /((http|https|ftp|smtp|rtsp):\/\/|www\.)/i;
    private htmlPattern=/([<>])/i;
    
    private addresses='';
    private honeypot = '';
    subject: string;
    note: string;
    gCaptchaResponse : string;
    // captchaSelected: boolean =true;

    _sendMailInProgress : boolean;
    public showPreview: boolean = false;

    constructor(private sendEmailService: SendEmailService,
                private jwtUtilService: JwtUtilService,
                private storageUtil: StorageUtil,
                private rtaService: RtaService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService){

        if (this.isUser()) {
            this.storageUtil.$localForage.getItem('userDetails').then((data) => {
                this.addresses = data !== null ? data.email : '';
            });
        }
        this.$translate('email.itemsfound').then((translation)=>{
            this.subject= translation;
        });
        this.note= '';
        this._sendMailInProgress = false;
        if(this.sendEmailService.isTemplateSupported(this.itemsToArray(this.selectedIds))){
            this.templateRenderingInProgress = true;
            this.sendEmailService.getPnxForSelectedIds(this.selectedIds).then((response) => {
                this.item = _get(response, 'data.docs');
                this.rtaService.updateAvailability(this.item);
            });
        }else if(this.sendEmailService.isTemplateSupported(this.itemsToArray(this.item))){
            this.templateRenderingInProgress = true; 
        }
        else{
            this.templateRenderingInProgress = false; 
        }
    }

    get emailRegEx() {
        return this.emailRegExAll;
    }
    
    get capchaPublicKey(){
        return getCaptcha().public_key;
    }
    
    get isCaptcha(){
        if( getCaptcha().isActiveCapcha=='Y') {
            return true;
        }else{
            return false;
        };
    }  
 
    private disableHtml(element) {
        this.note = this.note.replace(this.htmlPattern, '');
        this.note = this.note.replace(this.urlPattern, '');
    }
    
    private successfullSendAction(event, response) {
        console.log("email successfully sent");
        this._sendMailInProgress = false;
        this.finishedEmailEvent.emit(null); //throw event so action list directive can close the email form
    }

    private failedSendAction(event, response) {
        console.log("email failed to send");
        this._sendMailInProgress = false;
        this.finishedEmailEvent.emit(null); //throw event so action list directive can close the email form
    }

    private isUser() {
       let isUser = this.jwtUtilService.getDecodedToken().userGroup;
        if (isUser === 'GUEST'){
             return false;
        }
        return true;
     }
    private isGuest() {
        return !this.isUser();
    }

    sendEmail(event) {
        if (!this.isFormValid(event)){
            return;
        }
        
        this._sendMailInProgress = true;
        let failedAction = angular.bind(this, this.failedSendAction, event);
        let successAction = angular.bind(this, this.successfullSendAction, event);

        let sendEmailPromise = this.sendEmailService.sendEmail(this.addresses.split(/,|;/), this.subject, this.note, [this.item],this.gCaptchaResponse,this.selectedIds, this.isFullView);
        sendEmailPromise.then((response)=>successAction(response), (response)=>failedAction(response));
  
    }

    private isFormValid(event){
        return this.emailRegEx.test(this.addresses) && this.subject && this.isRecipientNumberValid() && this.isNoteSecured() && this.isCaptchaSet(event) && !this.honeypot;
    }
    
    
    private isNoteSecured(){
        return !this.urlPattern.test(this.note) && !this.htmlPattern.test(this.note);
    }
    
    private isRecipientNumberValid(){
        if (!this.addresses){
            return true;
        }
        let recipients=this.addresses.split(/,|;/);
        if(this.isUser()){
            if (recipients.length <=10){
                return true;
            }else{
                return false;
            } 
        }else{
            if(recipients.length <=1){
                return true;
            }else{
                return false;
            }
        }
    }
    
    private setWidgetId(widgetId){
        //console.log("Get widgetId from capture:"+widgetId);
        
    }
    
    private isCaptchaSet(event){
        if (this.isCaptcha){
            if(this.gCaptchaResponse){
                //event.$error.recaptchaResponse=false;
//              this.captchaSelected=true;
                return true;
            }else{
                //event.$error.recaptchaResponse=true;
//              this.captchaSelected=false;
                return false;
            }
        }else{
            //event.$error.recaptchaResponse=false;
//          this.captchaSelected=true;
            return true;
        }
    }

    
    
    private setResponse(response){
        //console.log("Get response from capture:"+response);
        this.gCaptchaResponse=response;
    }
    
    private changeAddress(emailForm){
        if(!this.isRecipientNumberValid()){
            emailForm.addresses.$error.validationError = true;
        }else{
            emailForm.addresses.$error.validationError = false;
        }
        
    }
    private changeNote(emailForm){
        
        if(this.urlPattern.test(this.note) || this.htmlPattern.test(this.note)){
            emailForm.note.$error.validationError = true;
        }else{
            emailForm.note.$error.validationError = false;
        }
        
    }

    public itemsToArray(item): any[]{
        return (!item || Array.isArray(item)) ? item : [item];
    }
    
    get sendMailInProgress() :boolean{
        return this._sendMailInProgress;
    }

    public goToEmailTemplate() {
        this.showPreview = !this.showPreview;
    }

    get renderedItems(): string {
        return this.sendEmailService.renderedItems;
    }

    set renderedItems(items: string) {
        this.templateRenderingInProgress = false;
        this.sendEmailService.renderedItems = items;
    }

    get templateRenderingInProgress(): boolean {
        return this.sendEmailService.templateRenderingInProgress ;
    }

    set templateRenderingInProgress(inProgress: boolean) {
        this.sendEmailService.templateRenderingInProgress = inProgress;
    }

}







// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/sendEmailAction/sendEmail.directive.ts